export default __webpack_public_path__ + "static/media/Group9193.72f3ae1e.svg";